import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'
import { dateTimeToPlainFormat } from '@/utils'

export interface ReserveContact {
  userId: string
  userName: string
  userNameKana: string
  reserveReceiveCount: number
  reserveCount: number
  reserveContactTime: string
  userType: SystemCode
}

export function ReserveContactFromJSON(json: any): ReserveContact {
  return ReserveContactFromJSONTyped(json)
}

export function ReserveContactFromJSONTyped(json: any): ReserveContact {
  if (json === undefined || json === null) {
    return json
  }
  return {
    userId: exists(json, 'user_id') ? json.user_id : '',
    userName: exists(json, 'user_name') ? json.user_name : '',
    userNameKana: exists(json, 'user_name_kana') ? json.user_name_kana : '',
    reserveReceiveCount: exists(json, 'reserve_receive_count')
      ? json.reserve_receive_count
      : 0,
    reserveCount: exists(json, 'reserve_count') ? json.reserve_count : 0,
    reserveContactTime: exists(json, 'reserve_contact_time')
      ? dateTimeToPlainFormat(json.reserve_contact_time)
      : '',
    userType: exists(json, 'user_type')
      ? SystemCodeFromJSON(json.user_type)
      : defaultSystemCode()
  }
}
